import type { ScreenerData } from "epsm-api-types/models";
import {
	formatValueCurrency,
	formatValueNumber,
} from "@/components/widgets/helpers/FormattingHelpers";
import { componentClassNames } from "../../../config";
import { LineHeader } from "../LineHeader";
import { QuoteRow } from "../QuoteRow";

export const StreetView = ({ data }: { data: ScreenerData | null }) => {
	if (!data) return null;

	const fields = [
		{
			label: "Target price High",
			value: data.tp_est?.high,
			format: formatValueCurrency,
		},
		{
			label: "Target price Mean",
			value: data.tp_est?.mean,
			format: formatValueCurrency,
		},
		{
			label: "Target price Low",
			value: data.tp_est?.low,
			format: formatValueCurrency,
		},
		{
			label: "# raise in last 7 days",
			value: data.tp_cnt_est_rev_up,
			format: formatValueNumber,
		},
		{
			label: "Analyst Reco.",
			value: data.analyst_recommendation?.["0_D"],
			format: formatValueNumber,
		},
		{
			label: "Analyst Reco. 30d ago",
			value: data.analyst_recommendation?.["1_M"],
			format: formatValueNumber,
		},
	];

	const visibleFields = fields.filter((f) => f.value != null);

	if (visibleFields.length === 0) return null;

	return (
		<div className={componentClassNames} data-testid="street-view">
			<LineHeader title="Street View" />
			{visibleFields.map(({ label, value, format }) => (
				<QuoteRow key={label} left={label} right={format(value)} />
			))}
		</div>
	);
};
